import { Icon } from '@/src/components/ui';
import { PartnerCheckmark } from '@/src/sections/settings/components/PartnerBadge';
import { cn } from '@workspace/ui/lib/utils';
import Link from 'next/link';

type Props = {
  authorId: number;
  fullName: string;
  authorImage: string;
  authorUniqueLink: string;
  children?: React.ReactNode;
  isPartner?: boolean;
};

export const MiniProfileInfo = ({
  authorId,
  fullName,
  authorImage,
  authorUniqueLink,
  children,
  isPartner = false,
}: Props) => {
  return (
    <Link href={`/${authorUniqueLink}`}>
      <div className="flex items-center gap-2 relative hover:underline">
        {authorImage ? (
          <img
            src={authorImage}
            alt={fullName}
            className="size-10 rounded-full"
          />
        ) : (
          <div className="border-1 border-black rounded-full border-box size-10 p-2">
            <Icon name="follow" className="size-5.5" />
          </div>
        )}
        <div className="flex flex-col">
          <span className="text-xs font-extralight">
            player3.io/<span className="font-medium">{authorUniqueLink}</span>
          </span>
          <span className="text-sm font-normal">{fullName}</span>
          {isPartner && <PartnerCheckmark />}
        </div>
        {children}
      </div>
    </Link>
  );
};

type AvatarProps = {
  authorImage?: string;
  fullName: string;
  className?: string;
};

export const AvatarOrFallback = ({
  authorImage,
  fullName,
  className,
}: AvatarProps) => {
  return authorImage ? (
    <img
      src={authorImage}
      alt={fullName}
      className={cn('size-10 rounded-full bg-white', className)}
    />
  ) : (
    <div className="border-1 border-black rounded-full border-box size-10 p-2">
      <Icon name="follow" className="size-5.5" />
    </div>
  );
};
